import { Menu } from 'src/app/interfaces/menu-item.interface';
import { AccountService } from 'src/app/services/account/account.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import {
    MatDialog,
    MatDialogConfig,
    MatDialogRef,
} from '@angular/material/dialog';
import { DialogLoaderComponent } from 'src/app/components/dialog-loader/dialog-loader.component';
@Component({
    selector: 'app-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.css'],
})
export class ResetComponent implements OnInit {
    dialogRef: MatDialogRef<DialogComponent> | undefined;
    restForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });
    isLoading: boolean = false;

    constructor(
        public dialog: MatDialog,
        private accountService: AccountService
    ) {}

    ngOnInit(): void {}
    openDialog() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.panelClass = 'loader-dialog';
        this.dialog.open(DialogLoaderComponent, dialogConfig);
    }
    closeDialog() {
        this.dialog.closeAll();
    }
    onSupport(href: string) {
        window.location.href = href;
    }
    async sendResetPassword() {
        if (window.navigator.onLine) {
            this.isLoading = true;
            this.openDialog();

            await this.accountService
                .resetPassword(this.restForm.value.email)
                .then((data: any) => {
                    this.closeDialog();
                    if (data && data.status) {
                        this.dialogRef = this.dialog.open(DialogComponent);
                        this.dialogRef.componentInstance.heading =
                            'Information';
                        this.dialogRef.componentInstance.messages = [
                            'ACCOUNT.RESET_MSG',
                        ];
                    } else {
                        this.dialogRef = this.dialog.open(DialogComponent);
                        this.dialogRef.componentInstance.heading =
                            'Information';
                        this.dialogRef.componentInstance.messages = [
                            'ACCOUNT.RESET_MSG_ERROR',
                        ];
                    }
                });
        } else {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.heading = 'Information';
            this.dialogRef.componentInstance.messages = ['GENERAL.NO_INTERNET'];
        }
    }
}
